import { PageSideQrCode, TopBar } from 'businessCommon/src/components';
import { lang } from '@umu/ukit-lang';
import React from 'react';
import { createRoot } from 'react-dom/client';
import ThemeConfigProvider from 'common/src/config/theme/themeConfig';
import { IWhitePaper } from './interface/pageData';
import { getAppData } from './service/whitePaper';

import CommercializePage from 'src/common/page';
import { App } from './app';
import { render as headerRenderer, IHeaderConfig } from '@umu/home-header';
import { render as footerRenderer, IFooterConfig } from '@umu/home-footer';
import { getMenuData } from 'plan/@planPricing/service/getMenuData';
import { langOptions } from 'common/const';
import 'common/src/styles/common.scss';
import 'businessCommon/src/styles/businessCommon.scss';
import './whitePaperMobile.scss';

class WhitePaperMobile extends CommercializePage<IWhitePaper> {
    constructor() {
        super(getAppData());
        this.setupPageTitle(this.getPageTitle());
        this.render();
    }

    public getInitState() {
        const state = {
            pageData: {
                contextInfo: getAppData('contextInfo'),
                userInfo: getAppData('userInfo') || {},
                referUrl: getAppData('refer_url'),
            },
        };
        return state;
    }

    public async renderHeaderAndFooter() {
        const MenuData = await getMenuData();
        this.renderHomeHeader(MenuData.header);
        this.renderFooter(MenuData.footer);
    }

    public renderHomeHeader(data: any) {
        const siteHost = getAppData('siteHost');
        const LANG = getAppData('Lang');
        const SYSTEM = getAppData('SYSTEM');
        const store = this.getInitState();
        const pageData = store.pageData;
        const userInfo = pageData.userInfo;

        // 未登录状态时，展示官网导航
        if (!(userInfo.umu_id && +userInfo.umu_id > 0)) {
            const config = {
                siteHost,
                platform: 'mobile',
                system: SYSTEM.toLocaleUpperCase(),
                lang: window.langMap[LANG as 'zh-cn'],
                headerData: data,
                langOptions,
            };
            setTimeout(() => {
                headerRenderer(config as IHeaderConfig, document.querySelector('.page-header') as HTMLElement);
            }, 100);
        }
    }

    public renderFooter(data: any) {
        const siteHost = getAppData('siteHost');
        const LANG = getAppData('Lang');
        const SYSTEM = getAppData('SYSTEM');
        const config = {
            siteHost,
            platform: 'mobile',
            system: SYSTEM.toLowerCase(),
            lang: window.langMap[LANG as 'zh-cn'],
            langOptions,
            footerData: data,
        };

        setTimeout(() => {
            footerRenderer(config as IFooterConfig, document.querySelector('.page-footer') as HTMLElement);
        }, 100);
    }

    public render() {
        const store = this.getInitState();
        const pageData = store.pageData;

        createRoot(document.querySelector('.doc')!).render(
            <ThemeConfigProvider>
                <div className="mobile">
                    <div className="page-header">
                        <TopBar userInfo={pageData.userInfo} title={''} />
                    </div>
                    <App referUrl={pageData.referUrl}></App>
                    <PageSideQrCode />
                    <div className="page-footer"></div>
                </div>
            </ThemeConfigProvider>,
        );

        this.renderHeaderAndFooter();
    }

    private getPageTitle() {
        return lang('联系 UMU 销售');
    }
}
export default new WhitePaperMobile();
